import React, { useState } from "react";
import Link from "./link";
const MenuItem = (props) => {
    const { path, label, databaseId, children } = props;
    const [dropDownState, setDropDown] = useState(false);
    return (React.createElement("li", { className: props.containerClassName + " " + (props.containerClasses || ""), onMouseOver: () => {
            if (props.dropdown === "hover") {
                setDropDown(true);
            }
        }, onMouseOut: () => {
            if (props.dropdown === "hover") {
                setDropDown(false);
            }
        }, onClick: () => {
            if (props.dropdown === "click") {
                setDropDown(!dropDownState);
            }
        }, onKeyDown: (e) => {
            if (!children.length) {
                return;
            }
            if (e.keyCode === 13) {
                // Enter
                e.stopPropagation();
                setDropDown(!dropDownState);
            }
            if (e.keyCode === 27) {
                // Escape
                if (dropDownState) {
                    e.stopPropagation();
                }
                setDropDown(false);
            }
        } },
        React.createElement(Link, { id: "menu-item-" + databaseId, to: path, className: props.linkClasses ? props.linkClasses : undefined, itemProp: "url", activeClassName: "active", "aria-expanded": children.length ? dropDownState : undefined, "aria-controls": children.length ? "dropdown-" + databaseId : undefined, title: label }, label),
        children.length ? (React.createElement("menu", { role: "menu", "aria-labelledby": "menu-item-" + databaseId, "aria-hidden": !dropDownState, id: "dropdown-" + databaseId, tabIndex: "-1" }, children.map((item) => (React.createElement(MenuItem, { key: item.id, path: item.connectedNode?.node?.uri || item.path, label: item.label, id: item.id, databaseId: item.databaseId, children: item.children, dropdown: props.dropdown }))))) : (React.createElement(React.Fragment, null))));
};
export default MenuItem;
